var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "div",
      { staticClass: "call-participants__logo" },
      [
        _vm.image
          ? _c("el-image", {
              staticClass: "call-screen__logo-image",
              attrs: { src: _vm.image, fit: "contain" },
            })
          : _c("div", { staticClass: "call-screen__logo-text" }, [
              _c("h2", [_vm._v(_vm._s(_vm.brand))]),
            ]),
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "call-participants__presentation" }, [
      _vm._v(_vm._s(_vm.name)),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "call-participants__phone" }, [
      _vm._v(_vm._s(_vm.phone)),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }